import { Component, ViewChild } from '@angular/core';
import { NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ExpenseFormItemComponent } from '../expense-form-item/expense-form-item.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ExpenseSubmitFormComponent } from '../expense-submit-form/expense-submit-form.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { ThumbnailAttachmentComponent } from '../../../Component/thumbnail-attachment/thumbnail-attachment.component';

@Component({
  selector: 'app-outstation',
  standalone: true,
  imports: [DataTablesModule, CommonModule, RouterModule, LoaderComponent, FormsModule, NgbDropdownModule, NgSelectModule,ThumbnailAttachmentComponent],
  templateUrl: './outstation.component.html',
  styleUrl: './outstation.component.scss'
})
export class OutstationComponent {
  isDisabled: boolean = false;
  Trips = [] as any;
  
  Filter = {
    ESS_ExpenseReportRequestId: null,
    TripMasterId: null,
    SelectType: 'ER',
    EmpMasterId: null,
    TravelType: 'Outstation',
    ESS_ExpenseRequestMainId: null,
    ESS_ExpenseRequestDetailsId: null,
  }

  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private expense: ExpenseService,
    private session: SessionService,
    private modalService: NgbModal,
    protected common: CommonService,
    private toast: ToastService,
    private dateFormat: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
    this.Filter.EmpMasterId = session.GetUserDetails().UserId;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_TripMaster_SelectUpdate();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_TripMaster_SelectUpdate() {
    this.isDisabled = true;
    this.expense.ESS_TripMaster_SelectUpdate({ SelectType: 'S', ESS_TripMasterID: 0, EmpMasterId: this.session.GetUserDetails().UserId }).subscribe({
      next: (response) => {
        this.Trips = response.Table.filter((e: any) => e.IsSendForApproval == 0);
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetDailyAttendanceInOutHistory() {
    this.TableDatas = Object.values([]);
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
    if (this.Trips.filter((e: any) => e.ESS_TripMasterID == this.Filter.TripMasterId)[0].IsSendForApproval == 1) {
      this.toast.show({ message: 'Selected trip send for approval', type: toastTypeEnum.warning });
    } else {
      if (this.Filter.TripMasterId != null && this.Filter.TripMasterId > 0) {
        this.isDisabled = true;
        this.expense.ESS_ExpenseRequest_SelectGet(this.Filter).subscribe({
          next: (response) => {
            if (response.Table1) {
              this.TableDatas = response.Table1;
              this.TableDatas.forEach((element: any) => {
                if (element.Attachment != null && element.Attachment != '') {
                  element.Attachment = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ExpenseFolder + '/' + element.Attachment
                }
              });
              this.TableDatas = Object.values(this.TableDatas);

              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.destroy();
                this.dtTrigger.next(null);
              });
            }
            this.isDisabled = false;
          },
          complete: () => {
          },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    }
  }

  addItem() {
    if (this.Filter.TripMasterId != null && this.Filter.TripMasterId > 0) {
      const modalRef = this.modalService.open(ExpenseFormItemComponent, { size: 'lg', backdrop: 'static', });
      modalRef.componentInstance.TravelType = 'Outstation';
      modalRef.componentInstance.TripMasterId = this.Filter.TripMasterId;
      modalRef.componentInstance.StartDate = this.dateFormat.parse(this.Trips.filter((e: any) => e.ESS_TripMasterID == this.Filter.TripMasterId)[0].FromDate);
      modalRef.componentInstance.EndDate = this.dateFormat.parse(this.Trips.filter((e: any) => e.ESS_TripMasterID == this.Filter.TripMasterId)[0].ToDate);
      modalRef.componentInstance.ESS_ExpenseRequestMainId = this.TableDatas.length > 0 ? this.TableDatas[0].ESS_ExpenseRequestMainId : null;

      modalRef.result.then(
        (result: any) => {
          if (result != undefined && result) {
            this.GetDailyAttendanceInOutHistory();
          }
        },
        () => { }
      );
    } else {
      this.toast.show({ message: 'Please select trip', type: toastTypeEnum.warning });
    }
  }

  CheckSubmit() {
    if (this.TableDatas.length > 0) {
      const modalRef = this.modalService.open(ExpenseSubmitFormComponent, { backdrop: 'static', });
      modalRef.componentInstance.TravelType = 'Outstation';
      modalRef.componentInstance.Ids = this.TableDatas.map((e: any) => e.ESS_ExpenseRequestDetailsId).toString();
      modalRef.componentInstance.ESS_ExpenseRequestMainId = this.TableDatas[0].ESS_ExpenseRequestMainId;

      modalRef.result.then(
        (result: any) => {
          if (result != undefined && result) {
            this.Filter.TripMasterId = null;
            this.ESS_TripMaster_SelectUpdate();
            this.GetDailyAttendanceInOutHistory();
          }
        },
        () => { }
      );
    } else {
      this.toast.show({ message: 'Please check atleast one item', type: toastTypeEnum.warning });
    }
  }

  Delete(id: any) {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want delete?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.expense.ESS_ExpenseRequestInsert({ SelectType: 'D', ESS_ExpenseRequestDetailsId: id }).subscribe({
          next: (response) => {
            if (response.Error_Code == "482") {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.GetDailyAttendanceInOutHistory();
                }
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  // CheckAll(event: any) {
  //   this.TableDatas.forEach((element: any) => {
  //     element.IsCheck = event.target.checked;
  //   });
  // }

  ESS_ExpenseRequestInsert() {
    if (this.TableDatas.length > 0) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to submit?';
      modalRef.result.then(result => {
        if (result) {
          this.isDisabled = true;
          this.expense.ESS_ExpenseRequestInsert({
            SelectType: 'FS',
            ESS_ExpenseRequestMainId: this.TableDatas[0].ESS_ExpenseRequestMainId,
            EmpMasterId: this.session.GetUserDetails().UserId,
            TravelType: 'Outstation',
            ReportName: null,
            FromDate: null as any,
            ToDate: null as any,
            ReportDesc: null,
            ESS_ExpenseRequestDetailsIds: this.TableDatas.map((e: any) => e.ESS_ExpenseRequestDetailsId).toString(),
          }).subscribe({
            next: (response) => {
              if (response.Error_Code == "486") {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.Filter.TripMasterId = null;
                    this.ESS_TripMaster_SelectUpdate();
                    this.GetDailyAttendanceInOutHistory();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      });
    } else {
      this.toast.show({ message: 'Please add atleast one item', type: toastTypeEnum.warning });
    }
  }

  calRequestAmountTotal() {
    return this.TableDatas.map((e: any) => e.ExpenseAmount != '' && e.ExpenseAmount != null ? parseFloat(e.ExpenseAmount) : 0).reduce((acc: any, cur: any) => acc + cur, 0);
  }
}
